// src/hooks/useAnalyseReportedRoutesWorker.jsx
import { useEffect, useMemo, useRef, useState } from "react"

export const useAnalyseReportedRoutesWorker = (fromPicker, toPicker, meteotrackerReportedWaypointsGeojson) => {
  const [analysedReportedRoutes, setAnalysedReportedRoutes] = useState(null)
  const [loading, setLoading] = useState(false)

  const workerRef = useRef(null)
  const requestIdRef = useRef(0)

  // init worker once
  if (typeof window !== "undefined" && workerRef.current == null) {
    // Vite / CRA with Webpack 5+ syntax
    workerRef.current = new Worker(new URL("../workers/reportedRouteAnalyserWorker.jsx", import.meta.url), {
      type: "module",
    })
  }

  useEffect(() => {
    const worker = workerRef.current
    if (!worker) return

    const handleMessage = (event) => {
      const { id, ok, result, error } = event.data || {}
      if (id !== requestIdRef.current) return // ignore stale responses

      if (!ok) {
        console.error("[useAnalyseReportedRoutesWorker] worker error:", error)
        setAnalysedReportedRoutes(null)
        setLoading(false)
        return
      }

      setAnalysedReportedRoutes(result)
      setLoading(false)
    }

    worker.addEventListener("message", handleMessage)
    return () => {
      worker.removeEventListener("message", handleMessage)
    }
  }, [])

  useEffect(() => {
    const worker = workerRef.current
    if (!worker) return

    if (!meteotrackerReportedWaypointsGeojson) {
      // Laufende Antwort verwerfen, sonst füllt sie den geleerten State wieder.
      requestIdRef.current++
      setAnalysedReportedRoutes(null)
      setLoading(false)
      return
    }

    // bump request id so only latest response counts
    const id = ++requestIdRef.current

    setLoading(true)
    worker.postMessage({
      id,
      fromPicker: fromPicker?.toISOString ? fromPicker.toISOString() : fromPicker,
      toPicker: toPicker?.toISOString ? toPicker.toISOString() : toPicker,
      meteotrackerReportedWaypointsGeojson,
    })
  }, [fromPicker, toPicker, meteotrackerReportedWaypointsGeojson])

  // for compatibility with previous hook:
  return useMemo(
    () => ({
      analysedReportedRoutes,
      loading,
    }),
    [analysedReportedRoutes, loading]
  )
}
